<!-- app-subdomain-creators\src\accountPages\NewsfeedPageCreator.vue -->

<template>
  <CreatePostNewsfeedModal
  v-if="currentFeatureInstanceId"
  :isOpen="isModalOpen"
  :mode="postModalMode"
  :initialPost="editingPost"
  :featureInstanceId="currentFeatureInstanceId"
  :postingAsName="postingAsName"
  :postingAsAvatarUrl="postingAsAvatarUrl"
  :startWithPoll="createModalStartWithPoll"
  @close="closeCreatePostOverlay"
  @post-created="handlePostCreated"
  @post-updated="handlePostUpdated"
/>

  <NewsfeedSettingsModal
    v-if="currentFeatureInstanceId"
    :isOpen="isSettingsOpen"
    :featureInstanceId="currentFeatureInstanceId"
    @close="closeSettingsModal"
    @saved="handleSettingsSaved"
  />
  <!-- Newsfeed search modal -->
<NewsfeedSearchModal
  v-if="currentFeatureInstanceId"
  v-model:open="isSearchOpen"
  :group-name="pageTitle"
  :current-user-name="postingAsName"
  :current-user-avatar="postingAsAvatarUrl"
  :feature-instance-id="currentFeatureInstanceId"
  @search="handleNewsfeedSearch"
  @open-your-posts="handleOpenYourPostsFromSearch"
  @open-search-tab="handleOpenSearchTabFromSearchModal"
/>
  <main v-if="isLoadingNewsfeeds" class="mx-auto w-full max-w-[1380px] pb-14">
    <div class="overflow-hidden rounded-[28px] border border-zinc-200 bg-white shadow-sm">
      <div class="grid min-h-[610px] animate-pulse lg:grid-cols-[1.05fr_0.95fr]">
        <div class="flex flex-col justify-center px-7 py-12 sm:px-12 lg:px-16"><div class="h-7 w-36 rounded-full bg-zinc-100" /><div class="mt-6 h-10 w-full max-w-xl rounded-lg bg-zinc-200" /><div class="mt-4 h-4 w-full max-w-lg rounded bg-zinc-100" /><div class="mt-2 h-4 w-4/5 max-w-md rounded bg-zinc-100" /><div class="mt-8 h-12 w-40 rounded-xl bg-zinc-200" /></div>
        <div class="m-8 rounded-3xl bg-gradient-to-br from-zinc-100 to-blue-50" />
      </div>
    </div>
  </main>

  <main v-else-if="!newsfeedInstances.length" class="mx-auto w-full max-w-[1380px] pb-14">
    <section class="overflow-hidden rounded-[28px] border border-zinc-200 bg-white shadow-sm">
      <div class="grid min-h-[610px] lg:grid-cols-[1.05fr_0.95fr]">
        <div class="flex flex-col justify-center px-7 py-12 sm:px-12 lg:px-16">
          <span class="mb-5 inline-flex w-fit items-center gap-2 rounded-full bg-blue-50 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-blue-700"><NewspaperIcon class="h-4 w-4" />Engage · Post</span>
          <h1 class="max-w-xl text-3xl font-bold tracking-tight text-zinc-950 sm:text-4xl">Add a Newsfeed product before creating your first post.</h1>
          <p class="mt-5 max-w-xl text-base leading-7 text-zinc-600">Newsfeed products create the community space where your posts, conversations, media, and scheduled updates appear. Add and design one in Theme Editor, then return here to start publishing.</p>
          <p v-if="newsfeedError" class="mt-4 max-w-xl rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700">{{ newsfeedError }}</p>
          <div class="mt-8"><router-link to="/creator/theme-editor" class="inline-flex items-center justify-center gap-2 rounded-xl bg-[#2478ff] px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-600">Open Theme Editor<ArrowUpRightIcon class="h-4 w-4" /></router-link></div>
          <div class="mt-10 grid gap-4 border-t border-zinc-100 pt-8 sm:grid-cols-3">
            <div v-for="item in newsfeedEmptyStateSteps" :key="item.label" class="flex gap-3 sm:block"><span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-zinc-950 text-xs font-bold text-white">{{ item.step }}</span><div class="sm:mt-3"><p class="text-sm font-semibold text-zinc-900">{{ item.label }}</p><p class="mt-1 text-xs leading-5 text-zinc-500">{{ item.copy }}</p></div></div>
          </div>
        </div>

        <div class="relative flex min-h-[420px] items-center justify-center overflow-hidden bg-gradient-to-br from-[#ecf4ff] via-white to-violet-100 p-10">
          <div class="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-blue-300/30 blur-3xl" /><div class="absolute -bottom-24 -left-20 h-72 w-72 rounded-full bg-violet-300/30 blur-3xl" />
          <div class="relative w-full max-w-[500px] rounded-[28px] border border-white/80 bg-white/85 p-5 shadow-2xl shadow-blue-900/10 backdrop-blur">
            <div class="flex items-center gap-3 border-b border-zinc-100 pb-4"><span class="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-blue-400 to-violet-500 text-sm font-bold text-white">YOU</span><div class="flex-1"><div class="h-3 w-32 rounded bg-zinc-200" /><div class="mt-2 h-2 w-20 rounded bg-zinc-100" /></div></div>
            <div class="mt-4 rounded-2xl border border-zinc-200 bg-zinc-50 p-4"><p class="text-sm text-zinc-400">Share an update with your community…</p><div class="mt-5 flex items-center justify-between"><div class="flex gap-2"><span class="h-8 w-8 rounded-lg bg-blue-100" /><span class="h-8 w-8 rounded-lg bg-violet-100" /></div><span class="h-9 w-20 rounded-lg bg-[#2478ff]" /></div></div>
            <div class="mt-4 rounded-2xl border border-zinc-100 p-4"><div class="h-3 w-3/4 rounded bg-zinc-200" /><div class="mt-3 h-2.5 w-full rounded bg-zinc-100" /><div class="mt-2 h-2.5 w-5/6 rounded bg-zinc-100" /><div class="mt-4 aspect-[2.2/1] rounded-xl bg-gradient-to-br from-blue-100 to-violet-100" /><div class="mt-4 flex gap-4 text-xs text-zinc-400"><span>♡ Reactions</span><span>○ Comments</span></div></div>
          </div>
        </div>
      </div>
    </section>
  </main>

  <main v-else class="-mx-4 sm:-mx-6 lg:-mx-8 -my-10">
    <!-- header section -->
    <div class="mx-auto w-full bg-white xl:px-0 border-zinc-200 ">
      <!-- newsfeed image -->
      <div class=" w-[1300px] mx-auto">

<div class="relative group mx-auto w-[1225px] rounded-b-lg h-[400px]">
  <!-- Skeleton shimmer while loading header (no URL chosen yet) -->
  <div
    v-if="!fbPageHeaderrImageSrc"
    class="rounded-b-xl h-full w-full bg-gradient-to-r from-zinc-200 via-zinc-100 to-zinc-200 animate-pulse"
  ></div>

  <!-- Real header image once we have a URL -->
  <img
    v-else
    class="absolute inset-0 rounded-b-xl object-cover dark:shadow-none shadow-lg dark:border-none border h-full w-full"
    :src="fbPageHeaderrImageSrc"
    alt="Newsfeed"
    @load="handleHeaderImgLoad"
    @error="handleHeaderImgError"
  />

  <!-- Hover overlay with camera icon (only when no custom header yet) -->
  <div
    v-if="!hasCustomHeaderImage"
    class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 transition-opacity duration-300 group-hover:opacity-100 cursor-pointer rounded-lg"
    @click="triggerFBPageImageUpload"
  >
    <div class="relative">
      <div class="opacity-75 bg-zinc-900 rounded-full p-4">
        <CameraIcon class="h-20 text-white cursor-pointer"></CameraIcon>
      </div>

      <!-- Tooltip -->
      <span
        class="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-zinc-900 opacity-75 text-white text-md rounded-lg px-2 py-1 text-center"
      >
        Add/Change Background
      </span>
    </div>
  </div>

  <!-- Small edit button (only when custom header already exists) -->
  <div
    v-else
    class="absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100 pointer-events-none rounded-lg"
  >
    <button
      type="button"
      class="pointer-events-auto absolute bottom-4 right-4 inline-flex items-center gap-2 px-4 py-2 bg-white text-zinc-900 font-semibold rounded-xl shadow-md hover:bg-zinc-100"
      @click.stop="triggerFBPageImageUpload"
    >
      <PencilIcon class="h-4 w-4" />
      Edit
    </button>
  </div>

  <!-- Hidden file input -->
  <input
    type="file"
    ref="fileInput"
    class="hidden"
    @change="updateFBPageHeaderImage"
  />
</div>

        <!-- group title with editable functionality and avatar section -->
        <div class="pt-7 mx-16 border-zinc-200 relative pb-5 ">
          <div class="">
            <!-- Title and Pencil Icon section -->
            <div class="flex items-center space-x-2 group cursor-pointer gap-4">
              <!-- Title or Input Field -->
              <div v-if="!isEditingTitle">
                <h3 class="py-1 px-2 text-3xl font-bold text-zinc-800 hover:bg-black hover:bg-opacity-10 hover:rounded-lg">
                  {{ pageTitle }}
                </h3>
              </div>
              <div v-else>
                <input
                  v-model="pageTitleInput"
                  type="text"
                  class="text-3xl font-bold border border-gray-300 p-1 rounded-md"
                />
              </div>

              <!-- Pencil Icon for Editing -->
              <button
                v-if="!isEditingTitle"
                @click="enableEditing"
                class="opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              >
                <PencilIcon class="h-5 w-5 text-zinc-600 cursor-pointer" />
              </button>

              <!-- Save and Checkmark for success -->
              <div v-if="isEditingTitle">
                <button @click="saveTitle" class="text-blue-600 bg-gray-200 px-2 py-1 rounded-lg">
                  Save
                </button>
              </div>
              <div v-if="showSuccessCheck" class="ml-2">
                <CheckCircleIcon class="h-7 w-7 text-green-600" />
              </div>

      <!-- Newsfeed instance selector (feature_id = 6) -->
        <div class="mx-16 flex items-center">
          <div
            class="relative w-64"
            @mouseenter="handleNewsfeedMouseEnter"
            @mouseleave="handleNewsfeedMouseLeave"
          >
            <button
              @click.stop="toggleNewsfeedDropdown"
              class="w-full flex items-center justify-between px-3 py-2 text-sm font-semibold border border-zinc-200 rounded-md bg-white hover:bg-zinc-50"
            >
              <span class="truncate">
                {{
                  isLoadingNewsfeeds
                    ? 'Loading newsfeeds...'
                    : (selectedNewsfeed
                      ? selectedNewsfeed.name
                      : 'Select Newsfeed')
                }}
              </span>
              <span class="text-zinc-400">▾</span>
            </button>

            <!-- Dropdown -->
            <div
              v-if="newsfeedDropdownOpen"
              class="absolute mt-1 w-full bg-white border border-zinc-200 rounded-md shadow-lg z-40"
            >
              <template v-if="newsfeedInstances.length">
                <div
                  v-for="nf in newsfeedInstances"
                  :key="nf.id"
                  @click="selectNewsfeed(nf)"
                  class="px-3 py-2 text-sm hover:bg-zinc-50 cursor-pointer truncate"
                >
                  {{ nf.name }}
                </div>
              </template>

              <div
                v-else
                class="px-3 py-2 text-sm text-zinc-400"
              >
                No Newsfeed features found
              </div>
            </div>
          </div>

          <p
            v-if="newsfeedError"
            class="ml-4 text-xs text-red-500"
          >
            {{ newsfeedError }}
          </p>
        </div>

            </div>

            <!-- privacy + member count -->
            <div class="flex items-center gap-2 mt-2 text-zinc-500 text-[15px]">
              <LockClosedIcon class="h-4"></LockClosedIcon>
              <p>Private group</p>

              <p v-if="showMemberCount" class="h-1 w-1 rounded-full bg-zinc-400"></p>

              <!-- member count label, e.g. '17 members' -->
              <p v-if="showMemberCount" class="font-semibold">{{ memberCountLabel }}</p>
            </div>


                        <!-- member avatars -->
            <div v-if="isHeaderMembersLoading" class="flex -space-x-1 mt-2">
              <div
                v-for="n in 5"
                :key="`header-avatar-skel-${n}`"
                class="inline-block h-8 w-8 rounded-full ring-2 ring-white bg-zinc-200 animate-pulse"
              ></div>
            </div>
            <div v-else class="mt-2 flex items-center gap-2">
              <div class="flex -space-x-1">
                <img
                  v-for="(avatar, index) in avatars"
                  :key="avatar.key || index"
                  :src="avatar.src"
                  :alt="avatar.name || ('Member Avatar ' + (index + 1))"
                  class="inline-block h-8 w-8 shrink-0 rounded-full bg-zinc-200 object-cover ring-2 ring-white"
                  :style="{ zIndex: avatars.length - index }"
                  @error="handleAvatarImgError"
                >
              </div>
              <p
                v-if="moreMembersText"
                class="text-sm font-semibold leading-none text-zinc-500"
              >
                {{ moreMembersText }}
              </p>
            </div>

          </div>

        </div>



      </div>
    </div>

    <!-- 👇 Sentinel used to detect when tabs enter sticky mode -->
    <div ref="tabsSentinel" class="h-px w-full"></div>

    <!-- sticky wrapper for nav -->
    <div class="sticky top-[54px] z-40 bg-white/85 backdrop-blur-sm border-b-3 shadow-sm">
      <!-- navigation -->
      <div
        class="flex items-center lg:w-[1175px] border-t border-zinc-300 mx-auto h-[54px]"
      >
        <!-- LEFT: Tabs container (always takes space, tabs only show when not collapsed) -->
<div class="flex-1 flex items-center">
  <Transition name="tabs-fade">
    <div
      v-if="!tabsCollapsed"
      class="flex gap-1"
    >
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="text-center h-[56px] rounded-lg flex items-center cursor-pointer transition-all relative pb-1 pt-[6px]"
        :class="{
          'border-b-[3px] border-[#2D8CFF] rounded-none': tab === activeTab,
          'border-b-[3px] border-transparent': tab !== activeTab
        }"
        @click="activeTab = tab"
      >
        <div
          class="px-4 py-1 h-full w-full flex items-center justify-center transition-all rounded-lg"
          :class="{
            'bg-none': tab === activeTab,
            'hover:bg-zinc-100': tab !== activeTab
          }"
        >
          <h3
            class="text-sm font-medium"
            :class="{
              'text-[#2D8CFF]': tab === activeTab,
              'text-zinc-500': tab !== activeTab
            }"
          >
            {{ tab }}
          </h3>
        </div>
      </div>
    </div>
  </Transition>
</div>


      <!-- RIGHT: search + settings buttons (always visible, stay in place) -->
      <div class="flex items-center gap-2 flex-none">
        <button
          type="button"
          class="text-center px-4 h-[35px] bg-zinc-200 hover:bg-zinc-300 rounded-lg flex items-center cursor-pointer"
          :disabled="!currentFeatureInstanceId"
          @click="currentFeatureInstanceId && (isSearchOpen = true)"
        >
          <MagnifyingGlassIcon class="w-5 h-5 text-zinc-900" />
        </button>

        <button
          type="button"
          class="text-center px-3 h-[35px] bg-zinc-200 hover:bg-zinc-300 rounded-lg flex items-center cursor-pointer"
          :disabled="!currentFeatureInstanceId"
          @click="openSettingsModal"
        >
          <Cog6ToothIcon class="w-5 h-5 text-zinc-900" />
        </button>
      </div>


      </div>
    </div>

<!-- Sticky nav + tab content section -->
<div class="bg-[#f3f5fa]">

  <Transition name="tab-content-fade">
    <div v-show="activeTab === 'Discussion'" key="tab-discussion">
      <NewsfeedCreatorDiscussionTab
        v-if="currentFeatureInstanceId"
        ref="discussionTabRef"
        :featureInstanceId="currentFeatureInstanceId"
        :postingAsName="postingAsName"
        :postingAsAvatarUrl="postingAsAvatarUrl"
        :openPostSlug="routePostSlug"
        @open-create-post="openCreatePostOverlay"
        @open-edit-post="openEditPostOverlay"
      />
    </div>
  </Transition>

  <Transition name="tab-content-fade">
    <div v-show="activeTab === 'Your Posts'" key="tab-your-posts">
      <NewsfeedCreatorYourPostsTab
         v-if="currentFeatureInstanceId"
         ref="yourPostsTabRef"
        :featureInstanceId="currentFeatureInstanceId"
        :postingAsName="postingAsName"
        :postingAsAvatarUrl="postingAsAvatarUrl"
        @open-edit-post="openEditPostOverlay"
      />
    </div>
  </Transition>

  <Transition name="tab-content-fade">
    <div v-show="activeTab === 'Saved'" key="tab-saved">
      <NewsfeedCreatorSavedTab
      v-if="currentFeatureInstanceId"
      ref="savedTabRef"
        :featureInstanceId="currentFeatureInstanceId"
        :postingAsName="postingAsName"
        :postingAsAvatarUrl="postingAsAvatarUrl"
        @open-edit-post="openEditPostOverlay"
      />
    </div>
  </Transition>

  <Transition name="tab-content-fade">
    <div v-show="activeTab === 'Scheduled'" key="tab-scheduled">
      <NewsfeedCreatorScheduledTab
         v-if="currentFeatureInstanceId"
         ref="scheduledTabRef"
        :featureInstanceId="currentFeatureInstanceId"
        :postingAsName="postingAsName"
        :postingAsAvatarUrl="postingAsAvatarUrl"
        @open-edit-post="openEditPostOverlay"
      />
    </div>
  </Transition>

  <Transition name="tab-content-fade">
    <div v-show="activeTab === 'Pending'" key="tab-pending">
      <NewsfeedCreatorPendingTab
        v-if="currentFeatureInstanceId"
        ref="pendingTabRef"
        :featureInstanceId="currentFeatureInstanceId"
        :postingAsName="postingAsName"
        :postingAsAvatarUrl="postingAsAvatarUrl"
      />
    </div>
  </Transition>

  <Transition name="tab-content-fade">
  <div v-show="activeTab === 'Media'" key="tab-media">
    <NewsfeedCreatorMediaTab
      v-if="currentFeatureInstanceId"
      ref="mediaTabRef"
      :featureInstanceId="currentFeatureInstanceId"
      :currentUserName="postingAsName"
      :currentUserAvatar="postingAsAvatarUrl"
    />
  </div>
</Transition>

<!-- 🔍 Hidden Search tab – only active when user clicks a result -->
  <Transition name="tab-content-fade">
    <div v-show="activeTab === 'Search'" key="tab-search">
      <NewsfeedCreatorSearchTab
        v-if="currentFeatureInstanceId"
        ref="searchTabRef"
        :featureInstanceId="currentFeatureInstanceId"
        :postingAsName="postingAsName"
        :postingAsAvatarUrl="postingAsAvatarUrl"
        :searchTerm="searchTabTerm"
        @open-edit-post="openEditPostOverlay"
      />
    </div>
  </Transition>



</div>


  </main>
</template>

<script setup>
import { ref, onMounted, watch, computed, onBeforeUnmount, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import CreatePostNewsfeedModal from '@/Components/CreatePostNewsfeedModal.vue';
import NewsfeedCreatorDiscussionTab from '@/Components/NewsfeedCreatorDiscussionTab.vue';
import NewsfeedCreatorYourPostsTab from '@/Components/NewsfeedCreatorYourPostsTab.vue';
import NewsfeedCreatorSavedTab from '@/Components/NewsfeedCreatorSavedTab.vue';
import NewsfeedCreatorScheduledTab from '@/Components/NewsfeedCreatorScheduledTab.vue';
import NewsfeedCreatorPendingTab from '@/Components/NewsfeedCreatorPendingTab.vue';
import NewsfeedCreatorMediaTab from '@/Components/NewsfeedCreatorMediaTab.vue';
import NewsfeedSettingsModal from '@/Components/NewsfeedSettingsModal.vue';
import NewsfeedSearchModal from '@/Components/NewsfeedSearchModal.vue';
import NewsfeedCreatorSearchTab from '@/Components/NewsfeedCreatorSearchTab.vue';


import {
  ArrowUpRightIcon,
  MagnifyingGlassIcon,
  NewspaperIcon,
  PencilIcon,
  CheckCircleIcon,
  CameraIcon,
  Cog6ToothIcon,
} from '@heroicons/vue/24/outline';

import { LockClosedIcon } from '@heroicons/vue/24/solid';

import { useNewsfeedInstanceStore } from '@/stores/newsfeedInstanceStore';

const apiProxyUrl = process.env.VUE_APP_API_PROXY_URL;
const app = getCurrentInstance();
const notify = app?.appContext?.config?.globalProperties?.$notify;
const route = useRoute();
const routePostSlug = computed(() =>
  typeof route.params?.postSlug === 'string' ? route.params.postSlug.trim() : ''
);

// ─────────────────────────────────────────────
// 🔹 Newsfeed feature instances (feature_id = 6)
// ─────────────────────────────────────────────

// Real vs simulated member counts for this newsfeed
const realMemberCount = ref(0);          // from backend / actual
const simulatedMemberCount = ref(null);  // optional override from backend (future)

// 🔹 "Posting as" profile for the creator on this newsfeed
const postingAsName = ref('You');
const postingAsAvatarUrl = ref(null);
const hideMemberCountEnabled = ref(false);
const isHeaderMembersLoading = ref(false);
const memberCountVisibilityResolved = ref(false);

// Effective count used in UI: prefer simulated if provided
const effectiveMemberCount = computed(() => {
  if (typeof simulatedMemberCount.value === 'number') {
    return simulatedMemberCount.value;
  }
  return typeof realMemberCount.value === 'number'
    ? realMemberCount.value
    : 0;
});

// Label for UI: "1 member" vs "2,503 members"
const memberCountLabel = computed(() => {
  const n = effectiveMemberCount.value || 0;

  // You can tweak this behavior if you want "No members yet"
  if (n === 1) return '1 member';
  return `${n.toLocaleString()} members`;
});

const showMemberCount = computed(() =>
  memberCountVisibilityResolved.value &&
  !isHeaderMembersLoading.value &&
  !hideMemberCountEnabled.value
);

const moreMembersText = computed(() => (
  memberCountVisibilityResolved.value &&
  !isHeaderMembersLoading.value &&
  hideMemberCountEnabled.value
    ? '...and more'
    : ''
));


const currentFeatureInstanceId = ref(null);

const newsfeedInstances = ref([]);        // [{ id, name, raw }]
const selectedNewsfeed = ref(null);       // currently chosen instance
const newsfeedDropdownOpen = ref(false);

const isLoadingNewsfeeds = ref(false);
const newsfeedError = ref(null);
const newsfeedHideTimer = ref(null);
const newsfeedEmptyStateSteps = [
  { step: 1, label: 'Add the product', copy: 'Choose Newsfeed inside Theme Editor.' },
  { step: 2, label: 'Style the space', copy: 'Set its name, banner, colors, and member experience.' },
  { step: 3, label: 'Start posting', copy: 'Return to Post to publish and schedule community updates.' },
];

// Toggle dropdown
const toggleNewsfeedDropdown = () => {
  if (newsfeedHideTimer.value) {
    clearTimeout(newsfeedHideTimer.value);
    newsfeedHideTimer.value = null;
  }
  newsfeedDropdownOpen.value = !newsfeedDropdownOpen.value;
};

const scheduleHideNewsfeedDropdown = () => {
  if (newsfeedHideTimer.value) {
    clearTimeout(newsfeedHideTimer.value);
  }
  newsfeedHideTimer.value = setTimeout(() => {
    newsfeedDropdownOpen.value = false;
    newsfeedHideTimer.value = null;
  }, 150);
};

const handleNewsfeedMouseEnter = () => {
  if (newsfeedHideTimer.value) {
    clearTimeout(newsfeedHideTimer.value);
    newsfeedHideTimer.value = null;
  }
};

const handleNewsfeedMouseLeave = () => {
  if (newsfeedDropdownOpen.value) {
    scheduleHideNewsfeedDropdown();
  }
};

// Called when user clicks an item in dropdown
function selectNewsfeed(nf) {
  selectedNewsfeed.value = nf || null;
  currentFeatureInstanceId.value = nf ? nf.id : null;
  newsfeedDropdownOpen.value = false;

  console.log(
    '[NewsfeedPageCreator] selected newsfeed instance:',
    selectedNewsfeed.value
  );
}

// Fetch all feature instances and filter to feature_id = 6
async function fetchNewsfeedInstances() {
  isLoadingNewsfeeds.value = true;
  newsfeedError.value = null;

  try {
    const res = await fetch(`${apiProxyUrl}/api/feature-instances`, {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!res.ok) {
      throw new Error(`Failed to fetch feature instances: ${res.status}`);
    }

    const data = await res.json();
    console.log('[NewsfeedPageCreator] /api/feature-instances response:', data);

    // Try the common shapes we’ve seen in your app
    const rawList =
      data.instances ||
      data.featureInstances ||
      data.items ||
      (Array.isArray(data) ? data : []);

    if (!Array.isArray(rawList)) {
      throw new Error('Unexpected feature-instances payload shape');
    }

    // Filter to Newsfeed = feature_id 6
// Filter to Newsfeed (feature_name = 'Newsfeed')
const filtered = rawList.filter((inst) => {
  // If backend *does* start sending feature_id one day, still support id=6
  const fid = Number(
    inst.feature_id ??
      inst.featureId ??
      inst.feature?.feature_id ??
      inst.feature?.id
  );
  if (Number.isFinite(fid) && fid === 6) {
    return true;
  }

  // Fallback: use feature_name / slug
  const name = String(inst.feature_name || inst.name || '').toLowerCase();
  const slug = String(inst.slug || '').toLowerCase();

  return name.includes('newsfeed') || slug.includes('newsfeed');
});


    const mapped = filtered.map((inst) => {
      const id =
        inst.instance_id ??
        inst.feature_instance_id ??
        inst.id;

      const name =
        inst.custom_name ||
        inst.slug ||
        inst.feature_name ||
        `Newsfeed #${id}`;

      return {
        id,
        name,
        raw: inst,
      };
    });

    newsfeedInstances.value = mapped;

    // Pick the first one as default (if any)
    selectedNewsfeed.value = mapped[0] || null;
    currentFeatureInstanceId.value = selectedNewsfeed.value
      ? selectedNewsfeed.value.id
      : null;

    console.log(
      '[NewsfeedPageCreator] newsfeedInstances:',
      newsfeedInstances.value
    );
    console.log(
      '[NewsfeedPageCreator] currentFeatureInstanceId:',
      currentFeatureInstanceId.value
    );
  } catch (err) {
    console.error('[NewsfeedPageCreator] error fetching newsfeed instances:', err);
    newsfeedError.value =
      err?.message || 'Failed to load Newsfeed feature instances';
  } finally {
    isLoadingNewsfeeds.value = false;
  }
}

const discussionTabRef = ref(null);
const scheduledTabRef = ref(null);
const savedTabRef = ref(null);
const yourPostsTabRef = ref(null);
const pendingTabRef = ref(null);
const mediaTabRef = ref(null);
const searchTabRef = ref(null);


// Called when modal successfully creates a post
async function handlePostCreated(newPost) {
  console.log('[NewsfeedPageCreator] post created:', newPost);

  const status = String(newPost?.status || newPost?.postStatus || '').toLowerCase();
  const isPendingApproval = status === 'pending_approval';
  const isScheduled =
    status === 'scheduled' ||
    !!newPost?.scheduledFor ||
    !!newPost?.scheduled_for;

  // Smooth path: inject only the new post into Discussion instead of full reload
  if (!isScheduled && !isPendingApproval) {
    let didUpsert = false;
    if (discussionTabRef.value?.addOrUpdatePostFromCreate) {
      try {
        didUpsert = await discussionTabRef.value.addOrUpdatePostFromCreate(newPost);
      } catch (err) {
        console.error('[NewsfeedPageCreator] addOrUpdatePostFromCreate failed:', err);
      }
    }

    if (!didUpsert && discussionTabRef.value?.reloadPosts) {
      discussionTabRef.value.reloadPosts();
    }
  }

  if (isPendingApproval && pendingTabRef.value?.reloadPosts) {
    pendingTabRef.value.reloadPosts();
  }

  // Scheduled tab should still refresh after create/schedule
  if (scheduledTabRef.value?.reloadPosts) {
    scheduledTabRef.value.reloadPosts();
  }

  // 🔥 Also refresh Media so new attachments show up right away
  if (mediaTabRef.value?.reloadMedia) {
    mediaTabRef.value.reloadMedia();
  }
}

async function handlePostUpdated(updatedPost) {
  console.log('[NewsfeedPageCreator] post updated:', updatedPost);

  let didUpsertDiscussion = false;
  if (discussionTabRef.value?.addOrUpdatePostFromUpdate) {
    try {
      didUpsertDiscussion = await discussionTabRef.value.addOrUpdatePostFromUpdate(
        updatedPost
      );
    } catch (err) {
      console.error('[NewsfeedPageCreator] addOrUpdatePostFromUpdate failed:', err);
    }
  }

  if (!didUpsertDiscussion && discussionTabRef.value?.reloadPosts) {
    discussionTabRef.value.reloadPosts();
  }

  let didUpsertYourPosts = false;
  if (yourPostsTabRef.value?.addOrUpdatePostFromUpdate) {
    try {
      didUpsertYourPosts = await yourPostsTabRef.value.addOrUpdatePostFromUpdate(
        updatedPost
      );
    } catch (err) {
      console.error('[NewsfeedPageCreator] yourPosts addOrUpdatePostFromUpdate failed:', err);
    }
  }
  if (!didUpsertYourPosts && yourPostsTabRef.value?.reloadPosts) {
    yourPostsTabRef.value.reloadPosts();
  }

  let didUpsertSaved = false;
  if (savedTabRef.value?.addOrUpdatePostFromUpdate) {
    try {
      didUpsertSaved = await savedTabRef.value.addOrUpdatePostFromUpdate(updatedPost);
    } catch (err) {
      console.error('[NewsfeedPageCreator] saved addOrUpdatePostFromUpdate failed:', err);
    }
  }
  if (!didUpsertSaved && savedTabRef.value?.reloadPosts) {
    savedTabRef.value.reloadPosts();
  }

  if (scheduledTabRef.value?.reloadPosts) {
    scheduledTabRef.value.reloadPosts();
  }

  if (pendingTabRef.value?.reloadPosts) {
    pendingTabRef.value.reloadPosts();
  }

  if (mediaTabRef.value?.reloadMedia) {
    mediaTabRef.value.reloadMedia();
  }
}





// ─────────────────────────────────────────────
// 🔹 Header image (per Newsfeed instance)
// ─────────────────────────────────────────────

const headerImgErrorCount = ref(0);
let headerLoadRequestId = 0;

const handleHeaderImgLoad = () => {
  headerImgErrorCount.value = 0;
};

const defaultHeaderImageSrc = new URL(
  '@/assets/media/images/groups-default-cover-photo-2x-compressed.png',
  import.meta.url
).href;

// What we actually show in the <img>
// ❌ OLD: const fbPageHeaderrImageSrc = ref(defaultHeaderImageSrc);
// ✅ NEW: start with null so we don't show default prematurely
const fbPageHeaderrImageSrc = ref(null);

// Pinia store for instance-specific stuff
const newsfeedInstanceStore = useNewsfeedInstanceStore();

const hasStoredCustomHeader = (entry) => !!(
  entry?.coverFileId ||
  entry?.coverMediaId ||
  entry?.secureImageUrl ||
  (entry?.coverImageUrl && entry.coverImageUrl !== defaultHeaderImageSrc)
);

const creatorNewsfeedImageByFileId = (fileId, instanceId = currentFeatureInstanceId.value) => {
  const normalizedFileId = String(fileId || '').trim();
  const normalizedInstanceId = Number(instanceId || 0);
  if (!normalizedFileId || !Number.isFinite(normalizedInstanceId) || normalizedInstanceId <= 0) {
    return '';
  }

  const params = new URLSearchParams({
    featureInstanceId: String(Math.trunc(normalizedInstanceId)),
  });
  return `${apiProxyUrl}/api/creator-newsfeed/image/${encodeURIComponent(normalizedFileId)}?${params.toString()}`;
};

const resolveCreatorHeaderImageSrc = (
  instanceId = currentFeatureInstanceId.value,
  { allowDefault = true, preferSignedUrl = false } = {}
) => {
  const entry = newsfeedInstanceStore.byId[String(instanceId)] || null;
  const proxiedUrl = creatorNewsfeedImageByFileId(entry?.coverFileId, instanceId);
  const signedOrRawUrl = String(entry?.secureImageUrl || entry?.coverImageUrl || '').trim();
  const customUrl = preferSignedUrl
    ? (signedOrRawUrl || proxiedUrl)
    : (proxiedUrl || signedOrRawUrl);

  if (customUrl) return customUrl;
  if (allowDefault && entry?.loaded && !hasStoredCustomHeader(entry)) {
    return defaultHeaderImageSrc;
  }
  return '';
};

const handleHeaderImgError = async (event) => {
  const failedSrc = String(event?.target?.src || fbPageHeaderrImageSrc.value || '').trim();
  const instanceId = Number(currentFeatureInstanceId.value || 0);
  headerImgErrorCount.value += 1;

  if (!Number.isFinite(instanceId) || instanceId <= 0) {
    fbPageHeaderrImageSrc.value = defaultHeaderImageSrc;
    return;
  }

  const entryBeforeRefresh = newsfeedInstanceStore.byId[String(instanceId)] || null;
  if (failedSrc.includes(defaultHeaderImageSrc) && !hasStoredCustomHeader(entryBeforeRefresh)) {
    fbPageHeaderrImageSrc.value = null;
    return;
  }

  const loaded = await newsfeedInstanceStore.ensureHeaderLoaded(instanceId, { force: true });
  if (Number(currentFeatureInstanceId.value) !== instanceId) return;

  const refreshedEntry = newsfeedInstanceStore.byId[String(instanceId)] || null;
  if (!hasStoredCustomHeader(refreshedEntry)) {
    fbPageHeaderrImageSrc.value = loaded ? defaultHeaderImageSrc : null;
    return;
  }

  if (headerImgErrorCount.value >= 2) {
    fbPageHeaderrImageSrc.value = null;
    return;
  }

  const failedWasProxy = failedSrc.includes('/api/creator-newsfeed/image/');
  const retryUrl = resolveCreatorHeaderImageSrc(instanceId, {
    allowDefault: false,
    preferSignedUrl: failedWasProxy,
  });
  fbPageHeaderrImageSrc.value = retryUrl && !failedSrc.includes(retryUrl)
    ? retryUrl
    : null;
};

const hasCustomHeaderImage = computed(() => {
  const instanceId = currentFeatureInstanceId.value;
  if (!instanceId) return false;

  const entry = newsfeedInstanceStore.byId[String(instanceId)];

  const fromStore = hasStoredCustomHeader(entry);

  if (fromStore) return true;

  const currentSrc = String(fbPageHeaderrImageSrc.value || '');
  if (!currentSrc || currentSrc === defaultHeaderImageSrc) return false;

  // Covers local pre-upload previews (data URLs) and canonical uploaded URLs.
  return true;
});

async function loadCreatorInstanceSettings(instanceId, fallbackEntry = null) {
  const markVisibilityResolved = () => {
    if (String(currentFeatureInstanceId.value || '') === String(instanceId || '')) {
      memberCountVisibilityResolved.value = true;
    }
  };

  try {
    const res = await fetch(
      `${apiProxyUrl}/api/creator-newsfeed/instance-settings?featureInstanceId=${instanceId}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (res.ok) {
      const data = await res.json();
      if (String(currentFeatureInstanceId.value || '') !== String(instanceId || '')) return;
      const settings = (data && data.settings) || {};

      postingAsName.value =
        settings.creatorPostingAsName ||
        (fallbackEntry && fallbackEntry.creatorPostingAsName) ||
        'You';

      postingAsAvatarUrl.value =
        settings.creatorPostingAsAvatarUrl ||
        (fallbackEntry && fallbackEntry.creatorPostingAsAvatarUrl) ||
        defaultMemberAvatar;

      hideMemberCountEnabled.value = !!settings.hideMemberCount;
      markVisibilityResolved();
      return;
    }

    console.error(
      '[NewsfeedPageCreator] instance-settings fetch NOT OK:',
      res.status
    );
  } catch (err) {
    console.error(
      '[NewsfeedPageCreator] error loading instance-settings:',
      err
    );
  }

  if (String(currentFeatureInstanceId.value || '') !== String(instanceId || '')) return;

  postingAsName.value =
    (fallbackEntry && fallbackEntry.creatorPostingAsName) || 'You';
  postingAsAvatarUrl.value =
    (fallbackEntry && fallbackEntry.creatorPostingAsAvatarUrl) || defaultMemberAvatar;
  hideMemberCountEnabled.value = false;
  markVisibilityResolved();
}

// Whenever the feature instance changes, load its header & update image + avatars + posting-as
watch(
  () => currentFeatureInstanceId.value,
  async (newId) => {
    const requestId = ++headerLoadRequestId;
    if (!newId) {
      // No instance selected → show default header, clear avatars + posting-as
      fbPageHeaderrImageSrc.value = defaultHeaderImageSrc;
      avatars.value = [];
      realMemberCount.value = 0;
      simulatedMemberCount.value = null;

      postingAsName.value = 'You';
      postingAsAvatarUrl.value = null;
      hideMemberCountEnabled.value = false;
      memberCountVisibilityResolved.value = false;
      isHeaderMembersLoading.value = false;
      return;
    }

    headerImgErrorCount.value = 0;
    const cachedHeaderUrl = resolveCreatorHeaderImageSrc(newId, { allowDefault: false });
    fbPageHeaderrImageSrc.value = cachedHeaderUrl || null;
    avatars.value = [];
    postingAsAvatarUrl.value = null;
    isHeaderMembersLoading.value = true;
    hideMemberCountEnabled.value = false;
    memberCountVisibilityResolved.value = false;
    const fallbackEntry = newsfeedInstanceStore.byId[String(newId)] || null;

    const headerPromise = (async () => {
      const cachedEntry = newsfeedInstanceStore.byId[String(newId)] || null;
      const refreshSignedUrl = !!cachedEntry?.loaded && !cachedEntry?.coverFileId;
      const loaded = await newsfeedInstanceStore.ensureHeaderLoaded(newId, {
        force: refreshSignedUrl,
      });
      if (requestId !== headerLoadRequestId) return;
      if (String(currentFeatureInstanceId.value || '') !== String(newId || '')) return;

      const effectiveUrl = resolveCreatorHeaderImageSrc(newId, { allowDefault: true });
      if (effectiveUrl) {
        fbPageHeaderrImageSrc.value = effectiveUrl;
      } else if (!loaded) {
        fbPageHeaderrImageSrc.value = cachedHeaderUrl || null;
      }
    })();

    await Promise.allSettled([
      headerPromise,
      fetchHeaderMembers(newId),
      loadCreatorInstanceSettings(newId, fallbackEntry),
    ]);
  },
  {
    immediate: false,
  }
);



// File input + header image upload
const fileInput = ref(null);
const isUploadingHeader = ref(false);

const triggerFBPageImageUpload = () => {
  fileInput.value && fileInput.value.click();
};

const updateFBPageHeaderImage = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  if (!currentFeatureInstanceId.value) {
    alert('Please select a Newsfeed first before setting a cover image.');
    return;
  }

  const instanceId = currentFeatureInstanceId.value;

  // 1) Instant local preview (so UI feels snappy)
  const reader = new FileReader();
  reader.onload = (e) => {
    fbPageHeaderrImageSrc.value = e.target.result;
  };
  reader.readAsDataURL(file);

  // 2) Real upload + save
  uploadHeaderForInstance(file, instanceId);
};

async function uploadHeaderForInstance(file, instanceId) {
  if (isUploadingHeader.value) return;
  isUploadingHeader.value = true;

  const previousSrc = fbPageHeaderrImageSrc.value;

  try {
    // --- Step 1: signed URL via BFF ---
    const signedRes = await fetch(`${apiProxyUrl}/api/generate-signed-url`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        filename: file.name,
        contentType: file.type || 'image/jpeg',
        fileType: 'image',
        folderId: null,
      }),
    });

    if (!signedRes.ok) {
      throw new Error(`Failed to get signed URL (${signedRes.status})`);
    }

    const { fileId, signedUrl, permanentUrl } = await signedRes.json();

    // --- Step 2: PUT upload to S3 ---
    const putRes = await fetch(signedUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type || 'image/jpeg',
      },
      body: file,
    });

    if (!putRes.ok) {
      throw new Error(`Header upload failed (${putRes.status})`);
    }

    // --- Step 3: create media_files record via BFF ---
    const recordRes = await fetch(`${apiProxyUrl}/api/create-record`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        fileId,
        fileName: file.name,
        fileUrl: permanentUrl,
        fileType: 'image',
        mimeType: file.type || 'image/jpeg',
        sizeBytes: file.size,
        folderId: null,
        durationSeconds: null,
        thumbnailUrl: null,
      }),
    });

    if (!recordRes.ok) {
      throw new Error(`Failed to create media record (${recordRes.status})`);
    }

    // We don't care about recordRes.body shape; next step resolves by fileId.

    // --- Step 4: save mapping in creator_newsfeed_settings ---
    const headerRes = await fetch(
      `${apiProxyUrl}/api/creator-newsfeed/instance-header`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          featureInstanceId: instanceId,
          headerFileId: fileId, // ⬅️ this is media_files.file_id (UUID)
        }),
      }
    );

    if (!headerRes.ok) {
      throw new Error(`Failed to save newsfeed header (${headerRes.status})`);
    }

    const headerData = await headerRes.json();

    // Prefer secure URL (server-signed S3 URL), then raw Exoscale, then the
    // permanentUrl returned from the upload step as a last fallback.
    const finalUrl =
      headerData.secureImageUrl ||
      headerData.coverImageUrl ||
      permanentUrl;

    // 🔁 Keep the store in sync for this instance
    newsfeedInstanceStore.setHeader(instanceId, {
  coverMediaId: headerData.coverMediaId ?? null,
  coverFileId: headerData.coverFileId ?? fileId ?? null,
  coverImageUrl: finalUrl,
  secureImageUrl: headerData.secureImageUrl ?? null,
  groupName: headerData.groupName ?? null,

  // 🔹 keep posting-as profile in the store
  creatorPostingAsName: headerData.creatorPostingAsName ?? null,
  creatorPostingAsAvatarUrl: headerData.creatorPostingAsAvatarUrl ?? null,
});


    // Reset error count and show the stable authenticated URL when possible.
    headerImgErrorCount.value = 0;
    fbPageHeaderrImageSrc.value =
      resolveCreatorHeaderImageSrc(instanceId, { allowDefault: false }) || finalUrl;



  } catch (err) {
    console.error('[NewsfeedPageCreator] uploadHeaderForInstance error:', err);
    alert(err?.message || 'Failed to upload header image');

    fbPageHeaderrImageSrc.value = previousSrc || defaultHeaderImageSrc;
  } finally {
    isUploadingHeader.value = false;
  }
}



// Page title + editing (derived from newsfeed instance)
const isEditingTitle = ref(false);
const pageTitleInput = ref('');
const showSuccessCheck = ref(false);

// Base title = what we show when *not* editing
// 1) Prefer the switcher name (custom_name → mapped.name)
// 2) Fallback to groupName from settings (if we ever use it)
// 3) Fallback to generic "Newsfeed"
const baseGroupTitle = () => {
  if (selectedNewsfeed.value && selectedNewsfeed.value.name) {
    return selectedNewsfeed.value.name;
  }

  const instanceId = currentFeatureInstanceId.value;
  if (instanceId) {
    const entry = newsfeedInstanceStore.byId[String(instanceId)];
    if (entry && entry.groupName) {
      return entry.groupName;
    }
  }

  return 'Newsfeed';
};

// What the template actually renders
const pageTitle = computed(() => {
  if (isEditingTitle.value) {
    // While editing, show whatever is in the input (or fallback)
    return pageTitleInput.value || baseGroupTitle();
  }
  return baseGroupTitle();
});

const enableEditing = () => {
  pageTitleInput.value = baseGroupTitle();
  isEditingTitle.value = true;
};

const saveTitle = () => {
  // For now this is only a local visual update;
  // later we can POST this to the backend to update group_name/custom_name.
  isEditingTitle.value = false;
  showSuccessCheck.value = true;

  setTimeout(() => {
    showSuccessCheck.value = false;
  }, 5000);
};


// Default member avatar for header row (used if member has no custom avatar)
const defaultMemberAvatar = new URL(
  '@/assets/media/images/default-avatar.png',
  import.meta.url
).href;


// Header avatars (populated from backend util)
const avatars = ref([]);
let headerMembersRequestId = 0;

const normalizeHeaderAvatarSrc = (rawUrl, instanceId) => {
  const raw = String(rawUrl || '').trim();
  if (!raw) return defaultMemberAvatar;
  const normalized = raw.toLowerCase();
  if (
    normalized.startsWith('@/assets/') ||
    normalized.startsWith('src/assets/') ||
    normalized.startsWith('/src/assets/') ||
    normalized.includes('/media/images/default-avatar.png') ||
    normalized.endsWith('/default-avatar.png') ||
    normalized === 'default-avatar.png'
  ) {
    return defaultMemberAvatar;
  }

  const legacyFileId = raw.match(/\/api\/image\/([0-9a-fA-F-]{8,})/)?.[1] || '';
  return creatorNewsfeedImageByFileId(legacyFileId, instanceId) || raw;
};

const handleAvatarImgError = (event) => {
  const image = event?.target;
  if (!image) return;
  image.onerror = null;
  image.src = defaultMemberAvatar;
};

/**
 * Fetch up to N members to display in the header avatar row
 * for the current newsfeed instance.
 */
async function fetchHeaderMembers(instanceId) {
  const requestId = ++headerMembersRequestId;
  isHeaderMembersLoading.value = true;
  if (!instanceId) {
    avatars.value = [];
    realMemberCount.value = 0;
    simulatedMemberCount.value = null;
    isHeaderMembersLoading.value = false;
    return;
  }

  try {
    const res = await fetch(
      `${apiProxyUrl}/api/creator-newsfeed/instance-header-members?featureInstanceId=${instanceId}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (!res.ok) {
      console.error(
        '[NewsfeedPageCreator] fetchHeaderMembers backend not OK:',
        res.status,
        res.statusText
      );
      if (requestId === headerMembersRequestId) {
        avatars.value = [];
        realMemberCount.value = 0;
        simulatedMemberCount.value = null;
      }
      return;
    }

    const data = await res.json();
    if (requestId !== headerMembersRequestId) return;
    if (String(currentFeatureInstanceId.value || '') !== String(instanceId || '')) return;
    const members = Array.isArray(data.members) ? data.members : [];

    avatars.value = members.map((m, index) => ({
      key: m.userId || m.avatarFileId || `${instanceId}-${index}`,
      src:
        creatorNewsfeedImageByFileId(m.avatarFileId, instanceId) ||
        normalizeHeaderAvatarSrc(m.avatarUrl, instanceId),
      name: m.displayName || 'Member',
    }));

    // Real count: prefer explicit field from backend, fallback to length
    if (typeof data.realMemberCount === 'number') {
      realMemberCount.value = data.realMemberCount;
    } else {
      realMemberCount.value = members.length;
    }

    // Simulated count: optional override provided by backend (future)
    if (typeof data.simulatedMemberCount === 'number') {
      simulatedMemberCount.value = data.simulatedMemberCount;
    } else {
      simulatedMemberCount.value = null;
    }
  } catch (err) {
    console.error('[NewsfeedPageCreator] fetchHeaderMembers error:', err);
    if (requestId === headerMembersRequestId) {
      avatars.value = [];
      realMemberCount.value = 0;
      simulatedMemberCount.value = null;
    }
  } finally {
    if (requestId === headerMembersRequestId) {
      isHeaderMembersLoading.value = false;
    }
  }
}


// Tabs
const activeTab = ref('Discussion');

// term used for the hidden "Search" tab
const searchTabTerm = ref('');

// Tabs list for header – Search only appears once you actually
// have a term (so it's effectively "hidden" until used)
const tabs = computed(() => {
  const base = ['Discussion', 'Your Posts', 'Saved', 'Scheduled', 'Pending', 'Media'];
  if (searchTabTerm.value) {
    base.push('Search');
  }
  return base;
});

function normalizeNewsfeedTabName(rawTab) {
  const value = String(rawTab || '').trim().toLowerCase();
  if (value === 'discussion') return 'Discussion';
  if (value === 'your posts' || value === 'your-posts' || value === 'your_posts') return 'Your Posts';
  if (value === 'saved') return 'Saved';
  if (value === 'scheduled') return 'Scheduled';
  if (value === 'pending') return 'Pending';
  if (value === 'media') return 'Media';
  if (value === 'search') return 'Search';
  return '';
}


// 👇 Track whether the tabs should collapse (sticky "utility" mode)
const tabsCollapsed = ref(false);
const tabsSentinel = ref(null);

// Modal visibility
const isModalOpen = ref(false);
const isSettingsOpen = ref(false);
const postModalMode = ref('create');
const editingPost = ref(null);
const createModalStartWithPoll = ref(false);

function openCreatePostOverlay(payload = null) {
  // Don’t open until we know which newsfeed instance to use
  if (!currentFeatureInstanceId.value) {
    alert(
      'Newsfeed is still initializing (no feature instance found yet). ' +
        'Please wait a moment or check that you have at least one Newsfeed feature instance (feature_id = 6).'
    );
    return;
  }
  createModalStartWithPoll.value = !!payload?.startWithPoll;
  postModalMode.value = 'create';
  editingPost.value = null;
  isModalOpen.value = true;
}

function openEditPostOverlay(payload) {
  const post = payload?.post || null;
  if (!post || !post.id) {
    console.warn('[NewsfeedPageCreator] openEditPostOverlay missing post payload');
    return;
  }

  if (!currentFeatureInstanceId.value) {
    alert(
      'Newsfeed is still initializing (no feature instance found yet). ' +
        'Please wait a moment or check that you have at least one Newsfeed feature instance (feature_id = 6).'
    );
    return;
  }

  postModalMode.value = 'edit';
  editingPost.value = { ...post };
  isModalOpen.value = true;
}

function closeCreatePostOverlay() {
  isModalOpen.value = false;
  postModalMode.value = 'create';
  editingPost.value = null;
  createModalStartWithPoll.value = false;
}

function openSettingsModal() {
  if (!currentFeatureInstanceId.value) {
    alert(
      'Please select a Newsfeed before adjusting settings.'
    );
    return;
  }
  isSettingsOpen.value = true;
}

function closeSettingsModal() {
  isSettingsOpen.value = false;
}


function handleSettingsSaved(settings) {
  console.log(
    '[NewsfeedPageCreator] settings saved for instance',
    currentFeatureInstanceId.value,
    settings
  );

  const s = settings || {};

  // Update the reactive "posting as" state immediately
  if (typeof s.creatorPostingAsName === 'string') {
    postingAsName.value = s.creatorPostingAsName || 'You';
  }

  if (typeof s.creatorPostingAsAvatarUrl === 'string') {
    postingAsAvatarUrl.value =
      s.creatorPostingAsAvatarUrl || defaultMemberAvatar;
  }

  if (typeof s.hideMemberCount !== 'undefined') {
    hideMemberCountEnabled.value = !!s.hideMemberCount;
    memberCountVisibilityResolved.value = true;
  }
  if (typeof notify === 'function') {
    notify({
      title: 'Settings updated',
      body: 'Newsfeed settings were saved successfully.',
      variant: 'success',
      duration: 10000,
    });
  }

  // Optional: refresh posts so newly loaded posts use the latest postedAs data
  if (discussionTabRef.value?.reloadPosts) {
    discussionTabRef.value.reloadPosts();
  }
}



// Search modal
const isSearchOpen = ref(false);

function handleNewsfeedSearch(term) {
  console.log('[NewsfeedPageCreator] search term from modal:', term);
  // We let the SearchTab handle the actual display; this is mostly for logging.
}

function handleOpenYourPostsFromSearch() {
  // Switch to Your Posts tab when clicking "See your group activity"
  activeTab.value = 'Your Posts';
}

// When user clicks a specific search result in the modal
function handleOpenSearchTabFromSearchModal(payload) {
  const term = (payload && payload.term) ? String(payload.term).trim() : '';
  if (!term) return;

  searchTabTerm.value = term;
  activeTab.value = 'Search';
}





watch(
  () => activeTab.value,
  (tab) => {
    if (tab === 'Discussion' && discussionTabRef.value?.reloadPosts) {
      discussionTabRef.value.reloadPosts();
    }

    if (tab === 'Your Posts' && yourPostsTabRef.value?.reloadPosts) {
      yourPostsTabRef.value.reloadPosts();
    }

    if (tab === 'Scheduled' && scheduledTabRef.value?.reloadPosts) {
      scheduledTabRef.value.reloadPosts();
    }

    if (tab === 'Pending' && pendingTabRef.value?.reloadPosts) {
      pendingTabRef.value.reloadPosts();
    }

    if (tab === 'Saved' && savedTabRef.value?.reloadPosts) {
      savedTabRef.value.reloadPosts();
    }

    if (tab === 'Media' && mediaTabRef.value?.reloadMedia) {
      mediaTabRef.value.reloadMedia();
    }
  }
);

watch(
  () => routePostSlug.value,
  (slug) => {
    if (!slug) return;
    activeTab.value = 'Discussion';
  },
  { immediate: true }
);

watch(
  () => route.query?.tab,
  (nextTab) => {
    const normalized = normalizeNewsfeedTabName(nextTab);
    if (!normalized) return;
    if (normalized === 'Search' && !searchTabTerm.value) return;
    activeTab.value = normalized;
  },
  { immediate: true }
);




let tabsObserver = null;

onMounted(() => {
  fetchNewsfeedInstances();

  const sentinel = tabsSentinel.value;
  if (sentinel && 'IntersectionObserver' in window) {
    tabsObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        // If the sentinel is NOT visible, we’ve scrolled past it
        // → nav is effectively sticky → hide tabs
        tabsCollapsed.value = !entry.isIntersecting;
      },
      {
        root: null,
        threshold: 0,
      }
    );

    tabsObserver.observe(sentinel);
  }
});

onBeforeUnmount(() => {
  if (tabsObserver) {
    tabsObserver.disconnect();
    tabsObserver = null;
  }
});


</script>


<style scoped>
/* Ensure the images don't get dragged around */
img {
  user-drag: none;
  user-select: none;
}

/* Avatar z-index for overlapping effect */
.z-1 {
  z-index: 1;
}
.z-2 {
  z-index: 2;
}
.z-3 {
  z-index: 3;
}

.tabs-fade-enter-active,
.tabs-fade-leave-active {
  transition: opacity 450ms ease, transform 250ms ease;
}


.tab-content-fade-enter-active,
.tab-content-fade-leave-active {
  transition: opacity 250ms ease;
}

.tab-content-fade-enter-from,
.tab-content-fade-leave-to {
  opacity: 0;
}

.tab-content-fade-enter-to,
.tab-content-fade-leave-from {
  opacity: 1;
}
</style>



